import { SESSION_STORAGE_KEY, STORAGE_LOCATION } from 'constants/browserCache';
import { getStorageItem, updateStorageItem } from 'utils/browserCache/browserCache';

/**
 * Save user's question field input to browser storage.
 * @param inputText New local storage value for inputText
 */
export const saveInputToStorage = (inputText: string) => {
  const currInitializeViewState = getStorageItem(
    STORAGE_LOCATION.SESSION_STORAGE,
    SESSION_STORAGE_KEY.CHAT_INITIALIZE_VIEW,
  );
  updateStorageItem(STORAGE_LOCATION.SESSION_STORAGE, SESSION_STORAGE_KEY.CHAT_INITIALIZE_VIEW, {
    ...currInitializeViewState,
    inputText,
  });
};
